import { Inject, Injectable } from '@angular/core';
import { mapFetchResultData } from '@x/common/graph';
import { Observable } from 'rxjs';
import {
  ShopAddWishlistItemGQL,
  ShopRemoveWishlistItemGQL,
  ShopWishListItemIdsGQL,
  ShopWishListItemsGQL,
} from './gql/shop-wishlist.gql.generated';
import { AuthorizationHeaderProvider, AUTHORIZATION_HEADER_PROVIDER } from './types/shop-auth';
import { IShopCollection } from './types/shop-collection';
import {
  TShopAddWishlistItemMutation,
  TShopRemoveWishlistItemMutation,
  TShopWishListItem,
  TShopWishListItemIdsQuery,
  TShopWishListItemsQuery,
} from './types/shop-whislist';

@Injectable()
export class ShopWishlistService {
  constructor(
    @Inject(AUTHORIZATION_HEADER_PROVIDER)
    private authHeader: AuthorizationHeaderProvider,
    private shopWishListItemIdsGQL: ShopWishListItemIdsGQL,
    private shopAddWishlistItemGQL: ShopAddWishlistItemGQL,
    private shopRemoveWishlistItemGQL: ShopRemoveWishlistItemGQL,
    private shopWishListItemsGQL: ShopWishListItemsGQL,
  ) {
    if (!authHeader) throw new Error('authHeader Provider is required');
  }

  getWishListItemIds(query: TShopWishListItemIdsQuery): Observable<number[]> {
    return this.shopWishListItemIdsGQL
      .fetch(query, this.authHeader.userAuthHeader)
      .pipe(mapFetchResultData((r) => r.shopWishlistItems?.map((i) => i.productId) ?? []));
  }

  getWishListItems(query: TShopWishListItemsQuery): Observable<IShopCollection<TShopWishListItem>> {
    return this.shopWishListItemsGQL.fetch(query, this.authHeader.userAuthHeader).pipe(
      mapFetchResultData(({ items, totalItemsCount }) => {
        return { totalItemsCount, items };
      }),
    );
  }

  addWishlistItem(query: TShopAddWishlistItemMutation): Observable<number> {
    return this.shopAddWishlistItemGQL
      .mutate(query, this.authHeader.userAuthHeader)
      .pipe(mapFetchResultData((r) => r.shopAddWishlistItem.productId));
  }

  removeWishlistItem(query: TShopRemoveWishlistItemMutation): Observable<number> {
    return this.shopRemoveWishlistItemGQL
      .mutate(query, this.authHeader.userAuthHeader)
      .pipe(mapFetchResultData((r) => r.shopRemoveWishlistItem));
  }
}
